import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const errorMessages = {
  "10006": "CVV com tamanho inválido",
};

const getErrorMessage = (key, defaultMessage) => {
  return errorMessages[key] || defaultMessage;
};

const showError = (error) => {
  const MySwal = withReactContent(Swal);
  let message = 'Erro desconhecido!';
  if (error.message)
    message = error.message;

  if (error.error) {
    message = 'Erro retornado pelo PagSeguro: <br>';
    for (const key in error.errors) {
      const specificMessage = getErrorMessage(key, `${key}: ${error.errors[key]}`);
      message += `<p><strong>${specificMessage}</strong></p>`;
    }
  }

  MySwal.fire({
    icon: "error",
    title: "Houve um erro!",
    html: message,
    confirmButtonText: "Ok",
    confirmButtonColor: "#dc3545",
  });
};

export default showError;
